<template>
  <div class="fixed pin z-30 pointer-events-none" @click.stop="$emit('leave')">
    <div class="flex items-center ml-24 min-h-screen pointer-events-none" :class="[modalPosition === true ? 'justify-end mr-16': '']">
      <div class="bg-white rounded-lg shadow-lg p-6 fixed bottom-0 w-2/5 pointer-events-auto" :style="{width}" @click.stop>
        <div
          class="bg-white absolute pin-t pin-r md:-mt-3 md:-mr-3 rounded-full p-2 shadow cursor-pointer z-50"
          @click.stop.prevent="$emit('leave')"
        >
          <icon name="delete" class="w-5 h-5" :center="false" />
        </div>
        <div class="w-full mb-8">
          <div class="h-full border-b">
            <h3 class="mb-8">Comments</h3>
            <div class="flex justify-end mb-2">
              <button v-if="modalPosition === false" class="rounded py-2 px-4 bg-grey-light flex items-center hover:bg-grey" @click="moveModal(1)"><i class="fas fa-arrow-right"></i></button>
              <button v-else class="rounded py-2 px-4 bg-grey-light flex items-center hover:bg-grey" @click="moveModal(2)"><i class="fas fa-arrow-left"></i></button>
            </div>
            <div class="space-y-6 mb-8">
              <p>
              Please make sure any comments regarding your personal details, social media,
              and Bio text you wish the Fine & Country Marketing team to review</p>
            </div>
            <div class="w-full h-32 mb-8">
              <div class="resize-none rounded-lg block h-full border ro hover:border-grey focus:border-grey-dark flex flex-col items-l">
                <textarea v-model="body" class="p-2 resize-none rounded-lg block w-full h-full leading-normal" name="comment" id="comment" cols="30" rows="10" placeholder="Type a comment here..."></textarea>
                <div class="flex w-full justify-end">
                  <div class="flex items-center">
                    <button class="bg-none text-blue rounded px-2 py-2 border-none" @click="addComment(user)"><icon class="h-8 w-8 text-blue" :center="false" name="plane"></icon></button>
                  </div>
                </div>
              </div>
              <p v-if="commentCheck" class="text-red">Please enter a comment</p>
            </div>
          </div>
        </div>
        <div class=" w-full h-64 overflow-y-scroll">
          <div v-if="!loadingComment">
            <div v-for="comment in comments" :key="comment.id" class="border rounded h-full flex flex-row items-center mb-4">
              <div class="ml-4">
                <icon name="user" class="w-6 h-6 mr-3" :class="comment.commenter_user_name === 'You' ? 'text-blue' : 'text-black'" :center="false" />
              </div>
              <div class="ml-4 overflow-x-scroll">
                <div class="flex flex-row mb-2">
                  <div class="mr-4 font-bold" :class="comment.commenter_user_name === 'You' ? 'text-blue' : 'text-black'" >{{comment.commenter_user_name}}</div>
                  <div>{{comment.created_at}}</div>
                </div>
                <div class="whitespace-pre-line inline-flex">
                  {{comment.body}}
                </div>
              </div>
            </div>
          </div>
           <loader v-if="loadingComment"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import Icon from '../Icon.vue'
export default {
  components: { Icon },
  name: 'ProfileComment',
  data () {
    return {
      comments: [],
      loadingComment: false,
      body: null,
      commentCheck: null,
      modalPosition: false
    }
  },
  props: {
    width: { type: String },
    height: { type: String },
    modalClass: { type: String },
    showCloseBtn: { type: Boolean },
    scrollY: { type: Boolean, default: true },
    user: { type: Object }
  },
  methods: {
    getComments (val) {
      this.loadingComment = true
      api.get('/user-comments/' + val.id).then((response) => {
        console.log(response.data)
        this.comments = response.data
        this.loadingComment = false
      })
    },
    moveModal (position) {
      if (position === 1) {
        this.modalPosition = true
      }
      if (position === 2) {
        this.modalPosition = false
      }
      console.log(this.modalPosition)
    },
    async addComment (val) {
      this.commentCheck = false
      if (!this.body) {
        this.commentCheck = true
        return
      }
      if (this.body.length === 0) {
        this.commentCheck = true
        return
      }
      let data = {
        body: this.body
      }
      await api.post('/add-comment/' + val.id, data).then(
        this.body = ''
      )
      this.getComments(this.user)
    }
  },
  created () {
    // document.body.classList.add('overflow-hidden')
    this.getComments(this.user)
  },
  beforeDestroy () {
    // document.body.classList.remove('overflow-hidden')
  }
}
</script>

<style lang="scss" scoped>
  .backdrop {
    background: rgba(0,0,0,.5)
  }
</style>
